export const getLanguageFromLocaleIdentifier = (locale = 'en-de') =>
  locale.split('-')[0];

export const getCountryFromLocaleIdentifier = (locale = 'en-de') =>
  locale.split('-')[1];
